import { render, staticRenderFns } from "./DataBindingTree.vue?vue&type=template&id=436266b4&"
import script from "./DataBindingTree.vue?vue&type=script&lang=js&"
export * from "./DataBindingTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports